import { render, staticRenderFns } from "./FailureIcon.vue?vue&type=template&id=c880f6e2&"
import script from "./FailureIcon.vue?vue&type=script&lang=ts&"
export * from "./FailureIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FailureIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports